export const generateAlternateLink = (href: string, hreflang: string) => {
  return {
    rel: 'alternate',
    href,
    hreflang,
  }
}

